module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Wallet3-179d1a81ba6d6d8ccf6e77271fccaf45.svg";